import { render, staticRenderFns } from "./App.vue?vue&type=template&id=bf5ade70&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=bf5ade70&prod&lang=css"
import style1 from "./App.vue?vue&type=style&index=1&id=bf5ade70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5ade70",
  null
  
)

export default component.exports